/** Build id, injected by Vite. See `define` in vite.config.ts. */
declare const __APP_VERSION__: string;

/** The build this tab is running. */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "dev";

/** Short, readable form for the UI: "2026-08-24 14:12". */
export function formatVersion(v: string): string {
  const m = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/.exec(v);
  return m ? `${m[1]} ${m[2]}` : v;
}
